import React, { useState } from "react";
import { Row, Col, Card, Typography, Divider, Layout, Alert } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";
import { IMAGES } from "../../../constants/images";
import { FormSolicitacao } from "./components/form-solicitacao";
import { FormRecuperacaoSenha } from "./components/form-recuperacao-senha";
const { Title, Text, Link } = Typography;

const styles = {
  row: {
    flexGrow: 1,
  },
};

export const RecuperacaoSenha = () => {
  const [matricula, setMatricula] = useState(null);

  return (
    <Row justify="center" align="middle" className="full-width" style={styles?.row}>
      <Col xs={23} sm={18} md={14} lg={12} xl={8} xxl={6}>
        <Card bordered={false}>
          <Row justify="space-around">
            <Col>
              <img width={140} src={IMAGES.recuperacaoSenha} style={{ objectFit: "cover" }} />
            </Col>
          </Row>
          <Title level={3} align="center">
            Recuperar Senha
          </Title>

          {matricula > 0 && <FormRecuperacaoSenha matricula={matricula} onBackPress={() => setMatricula(null)} />}
          {!(matricula > 0) && <FormSolicitacao onSuccess={(e) => setMatricula(e ?? null)} />}

          <Alert
            description={
              <Text>
                Caso tenha algum problema na solicitação do código, entre em contato com o setor de RH ou TI:
                <br />
                <Link target="_blank" underline href="https://wa.me/message/WKIFUWDNKN2FG1">
                  <WhatsAppOutlined /> (49) 9 9945-0650
                </Link>
              </Text>
            }
            type="info"
            showIcon
          />

          <Divider />

          <Layout.Content style={{ textAlign: "center" }}>
            <Text disabled>DPTO TI - COPÉRDIA &copy;</Text>
          </Layout.Content>
        </Card>
      </Col>
    </Row>
  );
};
